// AGC: Mock notification data for DroidFarm
// AGC: Contains all system notifications and user activity entries

import type { Notification, NotificationGroup } from '../types'

/**
 * AGC: Generate mock notifications
 * AGC: Includes all types: tasks, fields, financial, weather, crop, equipment, inventory, system, worker
 */
export const mockNotifications: Notification[] = [
  // AGC: === TODAY'S NOTIFICATIONS ===
  {
    id: 'notif-1',
    type: 'task',
    action: 'completed',
    priority: 'medium',
    title: 'Tarefa concluída: Irrigação Talhão Sul',
    description: 'Sistema de irrigação finalizado com sucesso',
    icon: '✅',
    timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(), // 30 min ago
    read: false,
    fieldId: 'field-1',
    plotId: 'plot-3',
    taskId: 'task-6',
    metadata: {
      category: 'irrigacao',
      user: 'João Silva',
      status: 'completed',
    },
  },
  {
    id: 'notif-2',
    type: 'weather',
    action: 'alert',
    priority: 'high',
    title: 'Alerta: Chuva prevista para hoje',
    description: '80% de chance de precipitação às 15h. Considere adiar pulverização.',
    icon: '🌧️',
    timestamp: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(), // 1 hour ago
    read: false,
    metadata: {
      status: 'active',
    },
  },
  {
    id: 'notif-3',
    type: 'financial',
    action: 'created',
    priority: 'low',
    title: 'Despesa registrada: Combustível',
    description: 'R$ 2.500,00 - Abastecimento de máquinas',
    icon: '💰',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
    read: false,
    transactionId: 'trans-15',
    metadata: {
      amount: 2500,
      category: 'combustivel',
      user: 'Carlos Mendes',
    },
  },
  {
    id: 'notif-4',
    type: 'field',
    action: 'created',
    priority: 'medium',
    title: 'Novo talhão cadastrado: Norte C',
    description: '45 hectares - Soja Intacta RR2',
    icon: '🗺️',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(), // 3 hours ago
    read: true,
    fieldId: 'field-1',
    plotId: 'plot-new-1',
    metadata: {
      category: 'soja',
      user: 'Carlos Mendes',
    },
  },
  {
    id: 'notif-5',
    type: 'task',
    action: 'created',
    priority: 'medium',
    title: 'Nova tarefa criada: Adubação',
    description: 'Aplicação de nitrogênio no Talhão Leste',
    icon: '📝',
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), // 4 hours ago
    read: true,
    fieldId: 'field-2',
    plotId: 'plot-5',
    taskId: 'task-new-1',
    metadata: {
      category: 'adubacao',
      user: 'Maria Oliveira',
      status: 'pending',
    },
  },
  {
    id: 'notif-6',
    type: 'equipment',
    action: 'reminder',
    priority: 'high',
    title: 'Manutenção preventiva: Trator John Deere',
    description: 'Troca de óleo e filtros agendada para amanhã',
    icon: '🔧',
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(), // 5 hours ago
    read: true,
    equipmentId: 'equip-1',
    metadata: {
      status: 'scheduled',
    },
  },

  // AGC: === YESTERDAY'S NOTIFICATIONS ===
  {
    id: 'notif-7',
    type: 'crop',
    action: 'status_change',
    priority: 'medium',
    title: 'Estágio atualizado: Floração iniciada',
    description: 'Soja no Talhão Norte B entrou em floração',
    icon: '🌸',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // 1 day ago
    read: true,
    fieldId: 'field-1',
    plotId: 'plot-2',
    metadata: {
      previousValue: 'vegetativo',
      newValue: 'floracao',
    },
  },
  {
    id: 'notif-8',
    type: 'financial',
    action: 'created',
    priority: 'medium',
    title: 'Receita registrada: Venda de milho',
    description: 'R$ 85.000,00 - 100 toneladas',
    icon: '📈',
    timestamp: new Date(Date.now() - 26 * 60 * 60 * 1000).toISOString(), // 26 hours ago
    read: true,
    transactionId: 'trans-14',
    metadata: {
      amount: 85000,
      category: 'venda',
      user: 'Carlos Mendes',
    },
  },
  {
    id: 'notif-9',
    type: 'inventory',
    action: 'alert',
    priority: 'high',
    title: 'Estoque baixo: Fertilizante NPK',
    description: 'Apenas 500kg restantes. Reposição recomendada.',
    icon: '📦',
    timestamp: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(), // 28 hours ago
    read: true,
    metadata: {
      category: 'fertilizantes',
      status: 'low_stock',
    },
  },
  {
    id: 'notif-10',
    type: 'worker',
    action: 'created',
    priority: 'low',
    title: 'Novo colaborador cadastrado',
    description: 'Pedro Santos - Operador de máquinas',
    icon: '👷',
    timestamp: new Date(Date.now() - 30 * 60 * 60 * 1000).toISOString(), // 30 hours ago
    read: true,
    workerId: 'worker-5',
    metadata: {
      user: 'Admin',
    },
  },
  {
    id: 'notif-11',
    type: 'task',
    action: 'overdue',
    priority: 'high',
    title: 'Tarefa atrasada: Pulverização',
    description: 'Aplicação de defensivo no Talhão Oeste está 2 dias atrasada',
    icon: '⚠️',
    timestamp: new Date(Date.now() - 32 * 60 * 60 * 1000).toISOString(), // 32 hours ago
    read: true,
    fieldId: 'field-3',
    taskId: 'task-8',
    metadata: {
      category: 'pulverizacao',
      status: 'overdue',
    },
  },

  // AGC: === THIS WEEK'S NOTIFICATIONS ===
  {
    id: 'notif-12',
    type: 'system',
    action: 'alert',
    priority: 'low',
    title: 'Dica do sistema',
    description: 'Configure alertas de clima para receber notificações automáticas',
    icon: '💡',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
    read: true,
  },
  {
    id: 'notif-13',
    type: 'field',
    action: 'updated',
    priority: 'low',
    title: 'Talhão atualizado: Sul A',
    description: 'Dados de irrigação atualizados',
    icon: '✏️',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
    read: true,
    fieldId: 'field-1',
    plotId: 'plot-3',
    metadata: {
      user: 'João Silva',
    },
  },
  {
    id: 'notif-14',
    type: 'equipment',
    action: 'completed',
    priority: 'medium',
    title: 'Manutenção concluída: Colheitadeira',
    description: 'Revisão completa finalizada - 45 itens verificados',
    icon: '🔧',
    timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(), // 4 days ago
    read: true,
    equipmentId: 'equip-2',
    metadata: {
      status: 'completed',
      user: 'Oficina Central',
    },
  },
  {
    id: 'notif-15',
    type: 'financial',
    action: 'created',
    priority: 'medium',
    title: 'Despesa registrada: Mão de obra',
    description: 'R$ 12.000,00 - Folha de pagamento semanal',
    icon: '💰',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
    read: true,
    transactionId: 'trans-13',
    metadata: {
      amount: 12000,
      category: 'mao-de-obra',
      user: 'RH',
    },
  },
  {
    id: 'notif-16',
    type: 'crop',
    action: 'alert',
    priority: 'high',
    title: 'Alerta fitossanitário: Ferrugem detectada',
    description: 'Sinais de ferrugem asiática no Talhão Norte A',
    icon: '🚨',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
    read: true,
    fieldId: 'field-1',
    plotId: 'plot-1',
    metadata: {
      status: 'requires_action',
    },
  },
  {
    id: 'notif-17',
    type: 'task',
    action: 'completed',
    priority: 'low',
    title: 'Tarefa concluída: Monitoramento',
    description: 'Inspeção semanal de pragas finalizada',
    icon: '✅',
    timestamp: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(), // 6 days ago
    read: true,
    fieldId: 'field-2',
    taskId: 'task-2',
    metadata: {
      category: 'monitoramento',
      user: 'Maria Oliveira',
    },
  },

  // AGC: === OLDER NOTIFICATIONS ===
  {
    id: 'notif-18',
    type: 'weather',
    action: 'alert',
    priority: 'medium',
    title: 'Previsão atualizada para a semana',
    description: 'Temperaturas elevadas esperadas - até 38°C',
    icon: '🌡️',
    timestamp: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(), // 8 days ago
    read: true,
  },
  {
    id: 'notif-19',
    type: 'system',
    action: 'alert',
    priority: 'low',
    title: 'Atualização do sistema',
    description: 'Nova versão 2.1.0 disponível com melhorias de performance',
    icon: '🔄',
    timestamp: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), // 10 days ago
    read: true,
  },
  {
    id: 'notif-20',
    type: 'financial',
    action: 'created',
    priority: 'high',
    title: 'Despesa registrada: Defensivos',
    description: 'R$ 45.000,00 - Fungicidas e herbicidas',
    icon: '💰',
    timestamp: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(), // 12 days ago
    read: true,
    transactionId: 'trans-10',
    metadata: {
      amount: 45000,
      category: 'defensivos',
      user: 'Carlos Mendes',
    },
  },
]

/**
 * AGC: Helper to format date labels for groups
 */
const getDateLabel = (date: Date): string => {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  const weekAgo = new Date(today)
  weekAgo.setDate(weekAgo.getDate() - 7)

  const notifDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())

  if (notifDate.getTime() === today.getTime()) {
    return 'Hoje'
  } else if (notifDate.getTime() === yesterday.getTime()) {
    return 'Ontem'
  } else if (notifDate >= weekAgo) {
    return 'Esta semana'
  } else {
    return 'Mais antigos'
  }
}

/**
 * AGC: Group notifications by date
 */
export const groupNotificationsByDate = (notifications: Notification[]): NotificationGroup[] => {
  // AGC: Sort by timestamp descending (newest first)
  const sorted = [...notifications].sort(
    (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  )

  // AGC: Group by date label
  const groups: Record<string, Notification[]> = {}
  const order = ['Hoje', 'Ontem', 'Esta semana', 'Mais antigos']

  sorted.forEach((notification) => {
    const label = getDateLabel(new Date(notification.timestamp))
    if (!groups[label]) {
      groups[label] = []
    }
    groups[label].push(notification)
  })

  // AGC: Convert to array maintaining order
  return order
    .filter((label) => groups[label]?.length > 0)
    .map((label) => ({
      label,
      date: label,
      notifications: groups[label],
    }))
}

/**
 * AGC: Get notification statistics
 */
export const getNotificationStats = (notifications: Notification[]) => {
  const stats = {
    total: notifications.length,
    unread: notifications.filter((n) => !n.read).length,
    byType: {} as Record<string, number>,
    byPriority: {} as Record<string, number>,
  }

  notifications.forEach((n) => {
    // AGC: Count by type
    stats.byType[n.type] = (stats.byType[n.type] || 0) + 1
    // AGC: Count by priority
    stats.byPriority[n.priority] = (stats.byPriority[n.priority] || 0) + 1
  })

  return stats
}






